import React, { useState, useEffect } from "react";
import {
    Breadcrumb,
    Col,
    Row,
    Card,
} from "@themesberg/react-bootstrap";
import Preloader from "../../components/Preloader";
import { useLocation } from "react-router-dom";
import { TnosDataTable } from "../../components/TnosDataTable";

export default () => {
    const [getDetailPartner, setDetailPartner] = useState();

    const location = useLocation()
    const institution_id = location.pathname.split("/")[3];
    const [getMessageEmptyData, setMessageEmptyData] = useState(
        "Belum ada transaksi pada hari ini"
    )

    useEffect(() => {
        const fetchDetailPartner = () => {
            fetch(`${process.env.REACT_APP_API_TAB_ORGANISASI}/partner/${institution_id}/responder`, {
                method: "POST"
            })
                .then((res) => res.json())
                .then((response) => {

                    console.log(response.data);

                    setDetailPartner(response.data)

                }).catch((error) => {
                    console.log("Error Fetching Data " + error);
                });
        }

        fetchDetailPartner();
    }, []);

    const TableRow = (props) => {
        const {
            num,
            email,
            name,
            phone_number,
            unique_responder_id,
            register_at
        } = props;

        return (
            <tr>
                <td className="text-center">{num}.</td>
                <td>{name}</td>
                <td className="text-center">{phone_number}</td>
                <td>{email}</td>
                <td className="text-center">{unique_responder_id}</td>
                <td className="text-center">{register_at}</td>
            </tr>
        );
    }

    return (
        <>
            <Row>
                <Preloader show={!getDetailPartner ? true : false} />
                <Row className="mt-4"></Row>
                <Breadcrumb
                    className="d-none d-md-inline-block"
                    listProps={{
                        className: "breadcrumb-dark breadcrumb-transparent",
                    }}
                >
                    <Breadcrumb.Item href="/data-akun/partner">
                        Data Akun
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Detail Akun Partner</Breadcrumb.Item>
                </Breadcrumb>
                <Col xs={12} xl={12}>
                    <Card border="light">
                        <Card.Body>
                            <TnosDataTable
                                data={
                                    <>
                                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th className="border-0 text-center">No.</th>
                                                <th className="border-0">Nama</th>
                                                <th className="border-0 text-center">Nomor HP</th>
                                                <th className="border-0">Email</th>
                                                <th className="border-0 text-center">Kode Referensi</th>
                                                <th className="border-0 text-center">Tanggal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getDetailPartner?.length > 0 ? (
                                                getDetailPartner?.map((td, index) => (
                                                    <TableRow
                                                        key={`order-success-${td.id}`}
                                                        {...td}
                                                        num={index + 1}
                                                    />
                                                ))
                                            ) : (
                                                <tr className="text-center">
                                                    <td colSpan={8}>{getMessageEmptyData}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </>
                                }
                            ></TnosDataTable>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};
